// DS: MO3.8
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '../utils/formatting';
import s from './DiscountLabel.scss';
const DiscountLabel = ({ discount, className, variant = 'percent', size = 'medium' })=>{
    const { t } = useTranslation();
    if (!discount || !discount.amount || !discount.amount.percent) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['discount']
    }, variant === 'percent' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, discount.amount.percent, "% ", t('common.off')), variant === 'dollars' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, formatDollars(discount.amount.usd), " ", t('common.off')), variant === 'sale' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, t('common.onSale'))));
};
DiscountLabel.displayName = 'DiscountLabel';
export default DiscountLabel;

//# sourceMappingURL=DiscountLabel.js.map